import { render, staticRenderFns } from "./Datatable.vue?vue&type=template&id=1cc9fad3&"
import script from "./DatatableScript.js?vue&type=script&lang=js&"
export * from "./DatatableScript.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports